import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, videos, conselho_etica } from '../../../settings';
import { DelayLink, CardSliderFotos } from '../../../components';

import './ConselhoEtica.scss';

class ConselhoEtica extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };

    this.conselho_etica = conselho_etica.pessoas;
    this.images = images;
    this.videos = videos;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Conselho de Ética - Governança Corporativa - {this.texts.title}</title>
        </Helmet>

        <div className="conselho-etica-home page-gradient page-gradient--green bg-gray" ref="conselho-etica-home">
        <section className="governanca-home-area governanca-header page-gradient__header">
            <div className="container tela-max">
              <div className="page-header">
                <h1 className="page-header__title tituto-top">
                  <img src={this.images.conselho_etica.icon_titulo_top} />
                  Conselho de Ética
                  <span className="gri_label_etica_1">
                    GRI <b>102-17</b>
                  </span>
                </h1>
              </div>
            </div>
            <div className="container tela-max-top tela-max-top-conselho">
              <div className="row flex margin-media-2020">
                <div className="col-7">
                  <Fade bottom>
                    <div className="page-header pading-medio padding-conselho-2020-medio">
                      
                     {/*  <p className="page-header__description gri_text_top_desc_conselho">
                      Iniciativa trabalhada no nosso plano de ação de 2019, a reestruturação do Conselho
                       de Ética foi concluída em 2020 e contou com o apoio de uma consultoria externa 
                       que ouviu diversos stakeholders, como membros do próprio grupo, ex-presidentes 
                       da ANBIMA e especialistas na área.
                      </p>
                      <p className="page-header__description gri_text_top_desc_conselho">
                      O novo modelo foi aprovado em março, quando a Assembleia Geral Extraordinária 
                      de associados aprovou mudanças na sua formação e atuação, dando mais autonomia
                       e independência às decisões do colegiado.
                      </p>
                      <p className="page-header__description gri_text_top_desc_conselho">
                      O órgão passou a ser composto por nove membros, sendo um presidente, um 
                      vice-presidente e sete conselheiros. Antes, podiam participar até sete 
                      representantes de associados.
                      </p>
                      <p className="page-header__description gri_text_top_desc_conselho">
                      O mandato também mudou de dois para quatro anos, com apenas uma reeleição. 
                      Entretanto, a cada dois anos, três membros (que correspondem a 1/3) devem 
                      ser renovados, o que é considerado uma boa prática de mercado.
                      </p>
                      <p className="page-header__description gri_text_top_desc_conselho">
                      Entre as suas funções, a maior mudança está relacionada à análise dos 
                      pedidos de filiação e adesão aos nossos códigos de autorregulação. Antes,
                       o Conselho analisava e passava o seu parecer à Diretoria, que tomava a
                       decisão final. Agora, essa responsabilidade é do próprio Conselho de Ética.
                      </p> */}

                      <p className="page-header__description gri_text_top_desc_conselho conselho-de-etica-2020-black">
                        Instância responsável por zelar pela conduta ética das instituições que fazem parte da ANBIMA, o Conselho de Ética foi remodelado em 2020, ganhando nova estrutura e mais autonomia.  <br/><br />
                        O órgão passou a ser composto por nove membros, sendo um presidente, um vice-presidente e sete conselheiros. Antes, eram até sete representantes de associados. <br/><br />
                        O mandato também mudou de dois para quatro anos, com apenas uma reeleição. A cada dois anos, três membros (que correspondem a um terço do colegiado) devem ser renovados, o que é considerada uma boa prática de mercado. <br/><br />
                        Entre as novas funções assumidas pelo Conselho de Ética está a análise e a aprovação/veto dos pedidos de filiação e adesão aos nossos códigos. Antes, o Conselho analisava e entregava o parecer à Diretoria, que tomava a decisão final. Agora, a responsabilidade é do próprio Conselho de Ética.
                      </p>
                    </div>
                  </Fade>
                </div>
                <div className="anime-top col-5">
                  <div className="row">
                    <Fade>
                      <div className="col-12 pessoas-animadas">
                        <img src={this.images.conselho_etica.pessoa_top} className="pessoa_top"/>
                        <img src={this.images.conselho_etica.pessoa_top_grafico_redondo} className="pessoa_top_grafico_redondo"/>
                        <img src={this.images.conselho_etica.pessoa_top_grafico_1} className="pessoa_top_grafico_1"/>
                        <img src={this.images.conselho_etica.pessoa_top_grafico_2} className="pessoa_top_grafico_2"/>
                        <img src={this.images.conselho_etica.pessoa_top_mobile} className="pessoa_top_mobile"/>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="governanca-body governanca-body--card page--blue">
            <div className="container">
              <div className="row">
                <div className="">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <div className="afazeres-container">
                        <h2 className="green">Principais atribuições</h2>
                        <div className="diretoria-body__content-itens">
                          <div>
                            <p>
                            Interpretar e aplicar o Código de Ética. Também deve instaurar e analisar processos 
                            de infração, propondo à Diretoria, quando necessário, penalidades aos associados que 
                            descumprirem as normas do código.
                            </p>
                          </div>
                          <div>
                            <p>
                            Elaborar e submeter à Assembleia, por meio da Diretoria, possíveis alterações no 
                            Código de Ética. O código foi revisado em 2020.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="governanca-body governanca-body--card page--blue">
            <div className="container">
              <div className="row">
                <div className="">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <h2 className="center-title-etica conselho-de-etica-2020">
                        Conselho de Ética em dezembro de 2020
                        {/* As novas competências do <b>conselho</b> entraram em vigor em maio, 
                        após a Assembleia de abril que aprovou os nomes dos seus membros. <b>São eles:</b> */}
                      </h2>

                      <CardSliderFotos
                        items={this.conselho_etica}
                        url={this.images.conselho_etica.path_url}
                        color={'green'}
                      />
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="conselho-etica-middle-area governanca-body">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <h2 className="big bordered_text bordered_text--dark-gray gri_text gri_text--fixed">
                      Códigos de conduta
                      <span className="gri_label">
                        GRI <b>102-16, 102-17, 102-33</b>
                      </span>
                    </h2>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <div className="card-etica">
                      <div className="card__content-etica card__content--full--etica">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title">Código de Ética ANBIMA</h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            O documento, que trata de temas como concorrência leal, utilização de informações 
                            privilegiadas e risco de capacidade de liquidação física ou financeira, foi revisado
                            em 2020. Antes voltado apenas aos associados, passou a ser obrigatório também a 
                            todas as instituições que seguem os nossos códigos de autorregulação. As normas do 
                            Código de Ética estabelecem padrões de conduta, com aspectos relacionados a responsabilidade,
                            transparência e boa-fé, com foco no interesse de clientes e investidores. A nova versão foi
                            aprovada em Assembleia Geral Extraordinária realizada em março e entrou em vigor em maio
                            de 2020. Confira neste{' '}
                            <a
                              href="https://www.anbima.com.br/pt_br/institucional/a-anbima/codigo-de-etica.htm"
                              target="_blank"
                              className="text_link text_link--white"
                            >
                              link
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <div className="card-etica">
                      <div className="card__content-etica card__content--full--etica">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title">Código de Ética e Conduta Profissional </h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Destinado aos nossos funcionários, aborda políticas corporativas, 
                            segurança da informação e investimentos pessoais, citando o uso 
                            indevido de informações privilegiadas e conflitos de interesse, 
                            entre outros. O código exige atuação íntegra, justa, legal e 
                            transparente, e os funcionários assinam um termo para atestar que 
                            estão de acordo com o documento no momento da contratação.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="conselho-etica-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--yellow box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-3 col--image">
                            {/* <img
                              src={this.images.conselho_etica.icone1}
                              className="icone_destaque icone_destaque--1--desktop"
                            />
                            <img
                              src={this.images.conselho_etica.icone1_mobile}
                              className="icone_destaque icone_destaque--1--mobile"
                            /> */}
                          </div>
                          <div className="col col-7 col--text box-conselho-etica-2020">
                            <h4>Conheça nossos organismos de representação</h4>
                            <DelayLink
                              to="/governanca-corporativa/organismos-de-representacao"
                              className="button button--aylen button--white-to-yellow button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { ConselhoEtica };
